import React, { useEffect, useState } from "react";
import { Accordion, Alert, Col, Form, Row, Table } from "react-bootstrap";
import { Helmet } from "react-helmet";

import Loader from "../../common/Loader";
import PageTitle from "../../common/PageTitle";
import { getFuelTanks } from "../../services/turgoil-api";
import { getNumberDisplayValue } from "../../utils/format";

const FuelTanksPage = (): React.ReactElement => {
  const [loading, setLoading] = useState(true);
  const [fuelTanks, setFuelTanks] = useState<any[]>([]);
  const [ipAddresses, setIpAddresses] = useState<string[]>([]);

  useEffect(() => {
    getFuelTanks()
      .then((res) => {
        setLoading(false);
        setFuelTanks(res.fuelTanks || []);
        setIpAddresses(res.ipAddresses || []);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>Turgoil - Mahutid</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
      </Helmet>
      <PageTitle>Mahutid</PageTitle>
      {loading && <Loader />}
      {!loading && (
        <div className="fuel-tanks">
          {ipAddresses.length && (
            <Alert variant="info">
              Selleks, et mahutite informatsiooni kuvada on vaja anda ligipääs
              järgmistele Turgoil-i IP aadressidele: {ipAddresses.join(" ja ")}.
            </Alert>
          )}
          {fuelTanks.length === 0 && (
            <span>
              Teil ei ole ühtegi mahutit. Mahutite seadistamiseks võtke meiega
              ühendust&nbsp;
              <a href="mailto:info@turgoil.com">info@turgoil.com</a> või{" "}
              <a href="tel:+3725138940">+372 513 8940</a>
            </span>
          )}

          {fuelTanks.length && (
            <Accordion defaultActiveKey={fuelTanks[0].ip}>
              {fuelTanks.map((f) => (
                <Accordion.Item key={f.ip} eventKey={f.ip}>
                  <Accordion.Header>
                    {f.ip} - {f.description}
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="row">
                      <Form.Group className="mb-2" as={Row}>
                        <Form.Label column sm={4}>
                          IP
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            className="form-control"
                            disabled
                            plaintext
                            value={f.ip}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group className="mb-2" as={Row}>
                        <Form.Label column sm={4}>
                          Seadme nimetus
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            className="form-control"
                            disabled
                            plaintext
                            value={[f.device.deviceName, f.device.modelName]
                              .filter((v) => v !== "")
                              .join(" - ")}
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group className="mb-2" as={Row}>
                        <Form.Label column sm={4}>
                          Seadme tööaeg
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            className="form-control"
                            disabled
                            plaintext
                            value={f.device.deviceUpTime}
                          />
                        </Col>
                      </Form.Group>

                      <Table
                        responsive
                        className="table-borderless table-hover"
                      >
                        <thead>
                          <tr>
                            <th>Mahuti nr</th>
                            <th>Kirjeldus</th>
                            {/* <th>Väärtus</th> */}
                            <th>Jääk</th>
                          </tr>
                        </thead>
                        <tbody>
                          {f.channels
                            .filter((c) => c.aiValueRaw !== 0)
                            .map((c) => (
                              <tr>
                                <td>{c.aiIndex}</td>
                                <td>{c.name}</td>
                                {/* <td>{f.aiValueRaw}</td> */}
                                <td>
                                  {getNumberDisplayValue(c.aiValueScaled, 2)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          )}
        </div>
      )}
    </>
  );
};

export default FuelTanksPage;
